import { UserLocale } from '@/shared/config';
import { normalizeInterfaceLocale } from '@/shared/lib';

export enum UserLocalSettingsKey {
  locale = 'locale',
}

export type UserLocalSettings = {
  [UserLocalSettingsKey.locale]: UserLocale;
};

export const getInitialUserSettings = (): UserLocalSettings => ({
  locale: normalizeInterfaceLocale(
    localStorage.getItem(UserLocalSettingsKey.locale),
  ),
});
